import { Component, OnInit } from '@angular/core'
import { CampaignInfo, CallsApiClient, AppUser } from '../shared/services/ppv.api'
import { AuthManager } from '../shared/auth/AuthManager'

@Component({
   selector: 'app-campaign-selector',
   templateUrl: './campaign-selector.component.html',
   styleUrls: ['./campaign-selector.component.scss'],
   standalone: false,
})
export class CampaignSelectorComponent implements OnInit {
   public isLoadingCalls = false
   public isLoadingAuth = false
   public campaigns: CampaignInfo[]
   public currentUser: AppUser
   public currentPractice: number = undefined

   constructor(private callsApiClient: CallsApiClient, private authManager: AuthManager) {}

   ngOnInit(): void {
      this.loadAuth()
      this.loadCampaignInfo()
   }

   onPracticeSKeySelected(practiceSKey: number) {
      this.currentPractice = practiceSKey
      this.loadCampaignInfo()
   }

   loadAuth() {
      this.isLoadingAuth = true
      this.authManager.getCurrentUser().subscribe((r) => {
         this.currentUser = r
         this.isLoadingAuth = false
      })
   }

   loadCampaignInfo() {
      if (!this.currentPractice) return

      this.isLoadingCalls = true
      console.log(typeof this.currentPractice)
      this.callsApiClient.getCampaigns(this.currentPractice).subscribe((r) => {
         console.log(r)
         if (r.success) {
            this.campaigns = r.result
         }
         this.isLoadingCalls = false
      })
   }

   generateLink(campaign: CampaignInfo) {
      if (this.currentPractice) {
         return `hospital/${this.currentPractice}/calls/${campaign.id}`
      } else {
         return `calls/${campaign.id}`
      }
   }
}
